import { AttendanceFilterModel } from "../../models/FormDataModel"
import { SELECTED_DATE, SET_FILTER, SET_SELECTED_LOCATIONS, SET_DEFAULT_EXPANDED_KEYS, RESET_FILTER, INITIALIZE_DEFAULTS } from "../actions/AttendanceAction"

const initialState = {   
    currentLocation :null,  
    filter: AttendanceFilterModel,
    isFilterApplied: false, 
    defaultExpandedKeys:{}   
}
const AttendanceReducer = (state = initialState, action)=>{
  
    switch(action.type){
        case INITIALIZE_DEFAULTS:
            return {...state, filter:{...state.filter, date: action.defaults.date, selectedLocations:action.defaults.selectedLocations}}
        case SET_DEFAULT_EXPANDED_KEYS:
            return {...state, defaultExpandedKeys:action.expandedKeys}
        case SET_SELECTED_LOCATIONS: 
            return {...state, filter: {...state.filter, selectedLocations:action.selectedLocations}}  
        case SELECTED_DATE:
            return {...state, filter: {...state.filter, date:action.date}}
        case SET_FILTER:
            return {...state, isFilterApplied: true, filter: {...state.filter, bedStatus:action.filter.bedStatus, bedType:action.filter.bedType, program: action.filter.program,
                bedMngmtStaffDetails: action.filter.bedMngmtStaffDetails, bedTags: action.filter.bedTags,
                occupancyStatus:action.filter.occupancyStatus, reservationStatus: action.filter.reservationStatus, activeStatus: action.filter.activeStatus}}
        case RESET_FILTER:
            return {...state,isFilterApplied: false, filter: {...state.filter, bedStatus:null, bedType:null, program: null,
                bedMngmtStaffDetails: null, bedTags: null, occupancyStatus: null, reservationStatus: null, activeStatus: null}}
    
        default:
            return {...state}           
    }

}

export default AttendanceReducer;